import { AutogenLayoutMarketArea } from "./autogen/AutogenLayoutMarketArea";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class MarketArea extends AutogenLayoutMarketArea {

    override onLoad(): void | Promise<void> {
        this.validateMarketAreaRecordExist();
    }

    private validateMarketAreaRecordExist() {
        const marketAreaUrl = "lme/dispatch/MarketArea?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "market_area", screenName: "MarketArea", navigateToUrl: marketAreaUrl };
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }
}
